var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"head_links_mobile",staticClass:"d-flex flex-column head-links",on:{"click":_vm.onClick}},[_c('MobileHeadLink',{attrs:{"links":_vm.links,"headerLinkTarget":_vm.headerLinkTarget}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }